import { render } from "./NewGroupTreeCheckBox.vue?vue&type=template&id=4118c11f&scoped=true"
import script from "./NewGroupTreeCheckBox.vue?vue&type=script&lang=js"
export * from "./NewGroupTreeCheckBox.vue?vue&type=script&lang=js"

import "./NewGroupTreeCheckBox.vue?vue&type=style&index=0&id=4118c11f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4118c11f"]])

export default __exports__